const preventDoubleTrad = (oldLangArray, newLangArray) => {
  let tmp = Array.isArray(newLangArray) ? [...newLangArray] : [newLangArray];
  [...oldLangArray].forEach((item) => {
    if (!tmp.find((element) => element.lang === item.lang)) tmp.push(item);
  });
  return tmp;
};

export default preventDoubleTrad;
